import { render } from "./Impressum.vue?vue&type=template&id=fb65a832&scoped=true"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=fb65a832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb65a832"]])

export default __exports__